import style from './wallex-technology.module.scss'
import Image from 'next/dist/client/image';
import { InView } from 'react-intersection-observer';
import animations from '@styles/animations.module.scss'

const WallexTechnologyItem = (props: any) => {
    let { state } = props;
    return (
        <InView triggerOnce={true}>
            {({ inView, ref, entry }) => {
                if (inView) {
                    entry?.target.classList.add(animations.active);
                }
                return (
                    <>
                        <div ref={ref} className={`${style.technology__block} ${animations.scroll__animation}`}>
                            <div className={style.technology__image}>
                                <Image alt='technology-icon' height={state.imageHeight} width={state.imageWidth} src={state.img} />
                            </div>
                            <div className={style.technology__name}>
                                {state.name}
                            </div>
                        </div>
                    </>
                )
            }}
        </InView>
    )


}

export default WallexTechnologyItem;
